import api from './api';

const inspectionService = {
  /**
   * Get the org-configured checklist (active MonitoringParameters) for a
   * project/category. Checklists are never hardcoded - they reflect
   * whatever the org has configured under Monitoring > Configure.
   */
  async getChecklist(params = {}) {
    const response = await api.get('/inspections/checklist', { params });
    return response.data;
  },

  /**
   * Submit a completed inspection. Non-compliant checklist items
   * automatically raise ComplianceFinding rows server-side.
   */
  async create(inspectionData) {
    const response = await api.post('/inspections', inspectionData);
    return response.data;
  },

  /**
   * List inspections, optionally filtered by project/category.
   */
  async getAll(params = {}) {
    const response = await api.get('/inspections', { params });
    return response.data;
  },

  /**
   * Get a single inspection by ID.
   */
  async getById(id) {
    const response = await api.get(`/inspections/${id}`);
    return response.data;
  },

  // ---- Compliance findings raised from inspections (or manually) ----

  async getFindings(params = {}) {
    const response = await api.get('/compliance/findings', { params });
    return response.data;
  },

  async createFinding(findingData) {
    const response = await api.post('/compliance/findings', findingData);
    return response.data;
  },

  async updateFinding(id, findingData) {
    const response = await api.patch(`/compliance/findings/${id}`, findingData);
    return response.data;
  },

  async getScore(params = {}) {
    const response = await api.get('/compliance/score', { params });
    return response.data;
  },

  // ---- Evidence attached to an inspection ----

  async uploadEvidence(inspectionId, file, fileType = 'photo') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileType', fileType);
    const response = await api.post(`/evidence/inspection/${inspectionId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async getEvidence(inspectionId) {
    const response = await api.get(`/evidence/inspection/${inspectionId}`);
    return response.data;
  },

  async deleteEvidence(evidenceId) {
    const response = await api.delete(`/evidence/${evidenceId}`);
    return response.data;
  },
};

export default inspectionService;
